/** Shown in homepage stats bar, about stats, and footer trust pills — keep in sync. */
export const PATIENTS_STAT = { number: "20,000+", label: "Patients across" };

export const FOOTER_PATIENTS_BADGE = "20,000+ Patients across";
